// @flow
import { connect } from 'react-redux';

import { createNewConversation } from '../../../actions';
import { setInviteCardOpen } from '../../../actions/conversation';
import { setCCMode, setShowBubbleAboveCCMode } from '../../../actions/cc-mode';

import CCPage from './CCPage';

const mapStateToProps = ({
  ccMode: { ccMode, showBubbleAboveCCMode },
  firebase: { user },
  scribeConversation: { isInviteCardOpen },
}) => ({
  ccMode,
  firebaseUser: user,
  isInviteCardOpen,
  showBubbleAboveCCMode,
});

const mapDispatchToProps = {
  createNewConversation,
  setCCMode,
  setInviteCardOpen,
  setShowBubbleAboveCCMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(CCPage);
